<template>
	<div class="field is-horizontal">
		<div class="field-body">
			<div class="field is-grouped">
				<div class="control">
					<input type="radio" name="default" @change="$emit('change-preferred')" :checked="phone.preferred">
				</div>
				<div class="control has-icons-left is-expanded">
					<input :disabled="readonly" class="input is-small is-success" type="text" placeholder="Phone Number" @keyup="updatePhone($event.target.value)" v-model="phone_number">
					<span class="icon is-small is-left">
					<i class="fa fa-phone"></i>
					</span>
				</div>
			</div>
			<div class="field">
				<div class="control is-expanded">
					<div class="select is-small is-fullwidth">
						<select v-model="phone.type">
							<option value="1">Landline</option>
							<option value="3">Cellular</option>
							<option value="2">Work</option>
						</select>
					</div>
				</div>
			</div>
			<div class="field">
				<div class="control is-expanded">
					<div class="select is-small is-fullwidth">
						<select v-model="phone.time_zone_id">
							<option value="3">Hawaiian</option>
							<option value="4">Alaskan</option>
							<option value="5">Pacific </option>
							<option value="8">Mountain </option>
							<option value="9">Central</option>
							<option value="11">Eastern</option>
							<option value="12">Atlantic</option>
							<option value="14">Newfoundland</option>
							<option value="61">Aus. Norfolk Island</option>
							<option value="62">Aus. Eastern</option>
							<option value="63">Aus. Central</option>
							<option value="64">Aus. Western</option>
							<option value="65">Aus. Christmas Island</option>
							<option value="66">England,Ireland</option>
						</select>
					</div>
				</div>
			</div>
			<div class="control">
				<input type="checkbox" name="default" @change="$emit('change-sms', $event.target.checked)" :checked="phone.sms">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			phone: Object,
			readonly: Boolean,
		},
		data() {
			return {
				ph: ''
			}
		},
		methods: {
			updatePhone(phone) {
				this.$emit('phone-number-changed', phone)
			}
		},
		computed: {
			phone_number: {
				get() {
					const phone = String(this.ph)
					if (this.phone.country_code === 1) {
						return `${phone.slice(0, 3)}${phone.length > 3 ? '-' : ''}${phone.slice(3, 6)}${phone.length > 6 ? '-' : ''}${phone.slice(6)}`
					} else {
						return phone
					}
				},
				set(val) {
					this.ph = val.replaceAll("-", "")
				}
			}
		},
		created() {
			this.ph = this.phone.phone_number
		}
	}
</script>